export const FORM_FIELD_NAMES = {
    AFFILIATE_ID: "affiliateId",
    CURRENCY_CODE: "currencyCode",
    PAYMENT_ID: "paymentId",
    AMOUNTS: "wallets",
    NOTES: "note",
    FILE: "file"
}